import { ChatMessageVerificationError } from '../../../errors/ChatMessageVerificationError';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageNeedCaptcha } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertNeedCaptchaStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.NeedCaptcha) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendGetCaptcha);

      dispatch(setFirstMessageNeedCaptcha());

      const error = new ChatMessageVerificationError({
        message: 'Отправка первого сообщения требует прохождения капчи',
        domain,
        details: { errorCode: response.status },
      });

      logger.warning(error);
    }
  };
